module.exports = __webpack_public_path__ + "img/smart-stewards.6571b112.png";